<template>
  <div>
    <CDialog DIALOGHEIGHT="70vh">
      <el-dialog
        :visible.sync="dialogVisible"
        class="cust-dialog"
        width="75%"
        append-to-body
        :close-on-click-modal="false"
        destroy-on-close
        @opened="dialogOpen"
        :before-close="handleDialogClose">
        <template slot="title">
          <div class="title-slot">选择自选板块</div>
        </template>
        <div class="dialog-content">
          <div class="dialog-left">
            <el-input
              placeholder="模糊搜索"
              v-model.trim="search"
              clearable
              @input="searchChange" />
            <div style="margin-top: 10px">
              <el-table
                ref="multipleTable"
                class="table1"
                :header-cell-style="tableStyle"
                :data="table_data"
                height="340"
                style="width: 100%">
                <el-table-column type="selection" width="55" />
                <el-table-column width="100" label="代码" prop="reit_code" />
                <el-table-column min-width="150" label="简称" prop="reitsName" />
                <el-table-column width="120" label="大类" prop="category_1" />
                <el-table-column width="120" label="细分" prop="category_2" />
              </el-table>
            </div>
            <div
              style="
                display: inline-block;
                margin-top: 10px;
                color: var(--primary-color);
                cursor: pointer;
              "
              @click="toggleSelection">
              反选
            </div>
            <div
              style="
                display: flex;
                align-items: center;
                margin-top: 10px;
                font-size: 14px;
                color: var(--chart_title);
              ">
              <i
                class="el-icon-question"
                style="
                  font-size: 20px;
                  color: rgb(64, 158, 255);
                  margin-right: 5px;
                  cursor: default;
                "></i>
              取消选择后并不会删除分组股票，您可以在【右侧】您的分组中点击【查看】进行删除操作
            </div>
          </div>
          <i class="el-icon-d-arrow-right" @click="reitAdd2Group" />
          <div class="dialog-right">
            <div class="list">
              <div
                class="item"
                :class="{ checked: item.checked, edit: item.edit }"
                v-for="(item, index) in nav_list"
                :key="item.id">
                <el-checkbox
                  v-if="item.id"
                  v-model="item.checked"
                  @change="handleCheckChange(item)($event)" />
                <div class="name">
                  <div v-if="!item.edit" class="flex items-center" @click="item.edit = true">
                    {{ item.name }}
                    <div class="icon-wrap">
                      <i class="el-icon-edit"></i>
                    </div>
                  </div>
                  <div v-else class="flex items-center" style="flex: 1">
                    <el-input
                      v-model="item.edit_value"
                      placeholder="请输入自选组名称"
                      maxlength="10"
                      autofocus />
                    <div
                      v-if="item.id"
                      class="icon-wrap"
                      style="background-color: var(--primary-color)"
                      @click="saveEdit(index)">
                      <i class="el-icon-check" style="color: #333" />
                    </div>
                    <div class="icon-wrap" @click="closeEdit(index)">
                      <i class="el-icon-close" />
                    </div>
                  </div>
                </div>
                <div v-if="!item.id" style="flex: none; margin-left: auto; margin-right: 0">
                  <span class="del add" @click="addGroup(item.edit_value)">新增</span>
                </div>
                <div v-if="item.id" style="flex: none; margin-left: auto; margin-right: 10px">
                  <span class="del" @click="showDetail(item)">查看</span>
                </div>
                <div v-if="item.id" style="flex: none; margin-left: auto; margin-right: 0">
                  <el-popover placement="top" width="160" v-model="item.del_visible">
                    <div style="padding-bottom: 20px">
                      <i
                        class="el-icon-warning"
                        style="color: #f0a913; margin-right: 4px" />你确定删除吗？
                    </div>
                    <div style="text-align: right; margin: 0">
                      <el-button
                        size="mini"
                        plain
                        @click="closeEdit(index)"
                        style="
                          background-color: transparent;
                          border-color: #616161;
                          color: var(--el-header-text-color);
                        "
                        >取消</el-button
                      >
                      <el-button
                        type="primary"
                        size="mini"
                        @click="delItem(index)"
                        style="
                          background-color: var(--primary-color);
                          border-color: var(--primary-color);
                          color: #333;
                        "
                        >确定</el-button
                      >
                    </div>
                    <span slot="reference" class="del">删除</span>
                  </el-popover>
                </div>
              </div>
              <div
                class="item add-item"
                :class="{ gray: nav_list.length >= 5 }"
                @click="handleAddGroup()">
                <i class="el-icon-plus" />
                添加
              </div>
            </div>
          </div>
        </div>
        <div class="btn-confirm" @click="reitAdd2Group">关闭</div>
      </el-dialog>
    </CDialog>
    <!-- 自选组详情 -->
    <CDialog DIALOGHEIGHT="70vh">
      <el-dialog
        :visible.sync="showDetailDialog"
        class="cust-dialog"
        width="40%"
        append-to-body
        :close-on-click-modal="false"
        destroy-on-close
        :title="detail_item.name"
        :before-close="handleDialogClose2">
        <div>
          <el-table
            class="table1"
            :header-cell-style="tableStyle"
            :data="detail_item.table_data"
            height="300"
            style="width: 100%">
            <el-table-column width="100" label="代码" prop="code" />
            <el-table-column width="150" label="简称" prop="name" />
            <el-table-column width="100" label="大类" prop="category_1" />
            <el-table-column min-width="120" label="细分" prop="category_2" />
            <el-table-column width="50">
              <template slot-scope="scope">
                <el-popover placement="top" width="160" :value="scope.row.del_visible">
                  <div style="padding-bottom: 20px">
                    <i
                      class="el-icon-warning"
                      style="color: #f0a913; margin-right: 4px" />你确定删除吗？
                  </div>
                  <div style="text-align: right; margin: 0">
                    <el-button
                      size="mini"
                      plain
                      @click="hideItemDelConfirm"
                      style="
                        background-color: transparent;
                        border-color: #616161;
                        color: var(--el-header-text-color);
                      "
                      >取消</el-button
                    >
                    <el-button
                      type="primary"
                      size="mini"
                      @click="delGroupCode(scope.row)"
                      style="
                        background-color: var(--primary-color);
                        border-color: var(--primary-color);
                        color: #333;
                      "
                      >确定</el-button
                    >
                  </div>
                  <span
                    slot="reference"
                    class="del cursor-pointer"
                    @click.stop="showItemDelConfirm(scope.$index)"
                    >删除</span
                  >
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-dialog>
    </CDialog>
  </div>
</template>

<script>
import CDialog from '@/components/Basic/CDialog';

import { sleep, debounce } from '@/utils';
import { fnReturnTableStyle } from '@/utils/util';
export default {
  props: { nav_list: Array, show: Boolean },
  components: {
    CDialog,
  },
  data() {
    const CODEobj = JSON.parse(localStorage.getItem('CODEobj')) || {};
    const CODELIST = JSON.parse(localStorage.getItem('CODELIST')) || [];
    const CODELISTObj = CODELIST.reduce((obj, item) => {
      obj[item.reitCode] = item;
      return obj;
    }, {});
    return {
      search: '',
      table_data: [],
      allREITsData: [],
      showDetailDialog: false,
      detail_item: {},
      CODEobj: Object.freeze(CODEobj),
      CODELISTObj: Object.freeze(CODELISTObj),
    };
  },
  computed: {
    tableStyle() {
      const val = this.$store.state.theme === 'dark';
      return () => fnReturnTableStyle(val);
    },
    dialogVisible: {
      get() {
        return this.show;
      },
      set(v) {
        this.$emit('update:show', v);
      },
    },
  },
  mounted() {
    this.getAllCodes();
  },
  methods: {
    dialogOpen() {
      const activeGroup = this.nav_list.find((item) => item.active);
      if (activeGroup) {
        activeGroup.checked = true;
        this.handleCheckChange(activeGroup)(true);
      }
    },
    showItemDelConfirm(index) {
      this.detail_item.table_data = this.detail_item.table_data.map((item, i) => {
        return {
          ...item,
          del_visible: i === index,
        };
      });
    },
    hideItemDelConfirm() {
      this.detail_item.table_data = this.detail_item.table_data.map((item) => {
        return {
          ...item,
          del_visible: false,
        };
      });
    },
    handleDialogClose2(done) {
      if (this.handleDialogClose2_cb) {
        this.handleDialogClose2_cb();
        this.handleDialogClose2_cb = null;
      }
      done();
    },
    // 删除组中code
    async delGroupCode({ code }) {
      const id = this.detail_item.id;
      if (this.lock_del3) return;
      this.lock_del3 = true;
      const { data } = await this.$https.get(
        `/api/v2/delete_user_reit_baisc?group_id=${id}&reit_code=${code}`
      );
      this.$root.$emit('reloadCodeName2');
      if (data.code !== 200) {
        this.$message.error(data.msg);
        await sleep(200);
        this.lock_del3 = false;
        return;
      }

      this.detail_item.table_data = this.detail_item.table_data.filter(
        (item) => item.code !== code
      );
      this.handleDialogClose2_cb = () => {
        const index = this.nav_list.findIndex((item) => item.active);
        this.$emit('loadGroups', index >= 0 ? index : undefined);
      };
      this.$message.success('删除成功');
      this.$refs.multipleTable.clearSelection();
      await sleep(200);
      this.lock_del3 = false;
    },
    showDetail(item) {
      this.showDetailDialog = true;
      const CODELISTObj = this.CODELISTObj;
      this.detail_item = {
        id: item.id,
        name: item.name,
        table_data: item.reit_codes.map((code) => {
          return {
            code,
            name: this.CODEobj[code],
            category_1: CODELISTObj[code].reitsTypeL1,
            category_2: CODELISTObj[code].reitsTypeL2,
            del_visible: false,
          };
        }),
      };
    },
    handleCheckChange(item) {
      return (v) => {
        const checked_item = this.nav_list.filter((item) => item.checked);
        if (checked_item.length > 1) {
          this.$refs.multipleTable.clearSelection();
          return;
        }
        if (!item.reit_codes.length) return;
        const rows = this.$refs.multipleTable.selection;
        if (v) {
          this.table_data.forEach((row) => {
            const status = rows.includes(row) || item.reit_codes.includes(row.reit_code);
            this.$refs.multipleTable.toggleRowSelection(row, status);
          });
        } else {
          if (checked_item.length) {
            this.table_data.forEach((row) => {
              const status =
                rows.includes(row) || checked_item[0].reit_codes.includes(row.reit_code);
              this.$refs.multipleTable.toggleRowSelection(row, status);
            });
          } else {
            this.table_data.forEach((row) => {
              const status = rows.includes(row) && !item.reit_codes.includes(row.reit_code);
              this.$refs.multipleTable.toggleRowSelection(row, status);
            });
          }
        }
      };
    },
    // 股票加入自选组
    async groupAddCode(id, code) {
      if (this.lock_add3) return;
      this.lock_add3 = true;
      const { data } = await this.$https.get(
        `/api/v2/add_user_reit_baisc?group_ids=${id}&reit_codes=${code}`
      );
      this.$root.$emit('reloadCodeName2');
      if (data.code !== 200) {
        this.$message.error(data.msg);
        await sleep(200);
        this.lock_add3 = false;
        return;
      }
      const index = this.nav_list.findIndex((item) => item.active);
      this.$emit('loadGroups', index >= 0 ? index : undefined);
      this.$message.success('添加成功');
      await sleep(200);
      this.lock_add3 = false;
    },
    // 股票加入自选组
    async reitAdd2Group(flag) {
      // 选中股票
      const rows = this.$refs.multipleTable.selection;
      // 选中组
      const groups = this.nav_list.filter((item) => item.checked);

      if (flag) {
        if (!rows.length || !groups.length) {
          this.$message.success('组合信息已保存');
          this.dialogVisible = false;
          return;
        }
      }

      if (!rows.length) {
        this.$message.warning('请选择需要添加到自选组的个券');
        return;
      }
      if (!groups.length) {
        this.$message.warning('请选择需要添加个券的自选组');
        return;
      }
      const group_ids = groups.map((item) => item.id).join(',');
      const reit_codes = rows.map((item) => item.reit_code).join(',');

      await this.groupAddCode(group_ids, reit_codes);
      this.$refs.multipleTable.clearSelection();
      if (flag) {
        this.$message.success('组合信息已保存');
        this.dialogVisible = false;
      }
    },
    async getAllCodes() {
      const { data } = await this.$https.get(
        `/api/v2_5/period_risk_single?annualize=0&single=single&r_type_=公募REITs&codes=`
      );
      if (data.code !== 200) return this.$message.error(data.msg);
      const result = Object.freeze(
        data.data.map((item) => ({
          reit_code: item.reit_code,
          reitsName: item.reitsName,
          category_1: item.category_1,
          category_2: item.category_2,
        }))
      );
      this.allREITsData = result;
      this.table_data = result;
    },
    _searchChange(qs) {
      if (!qs) {
        this.table_data = Object.freeze(this.allREITsData);
        return;
      }
      const result = this.allREITsData.filter((item) => {
        const { reit_code: code, reitsName: name, category_2, category_1 } = item;
        return (code + name + category_2 + category_1).indexOf(qs) >= 0;
      });
      this.table_data = Object.freeze(result);
    },
    searchChange: debounce(function (qs) {
      this._searchChange(qs);
    }, 360),
    toggleSelection() {
      const rows = this.$refs.multipleTable.selection;
      this.table_data.forEach((row) => {
        this.$refs.multipleTable.toggleRowSelection(row, !rows.includes(row));
      });
    },
    handleDialogClose(done) {
      const data = this.nav_list
        .filter((item) => item.id)
        .map((item) => ({
          ...item,
          del_visible: false,
          checked: false,
          edit: false,
          edit_value: item.name,
        }));
      this.$emit('update:nav_list', data);
      done();
    },
    handleAddGroup() {
      if (this.nav_list.length >= 5) {
        this.$message.warning('最多只能添加5个自选组');
        return;
      }
      this.nav_list.push({
        name: '',
        checked: false,
        edit: true,
        edit_value: '',
      });
    },
    async addGroup(name) {
      if (!name) {
        this.$message.warning('请输入组合名称');
        return;
      }
      if (this.lock_add) return;
      this.lock_add = true;
      const { data } = await this.$https.get(`/api/v2/add_user_reit_group?name=${name}`);
      this.$root.$emit('reloadCodeName2');
      if (data.code !== 200) {
        this.$message.error(data.msg);
        await sleep(200);
        this.lock_add = false;
        return;
      }
      this.$refs.multipleTable.clearSelection();
      this.$emit('loadGroups');
      await sleep(200);
      this.lock_add = false;
    },
    async saveEdit(index) {
      const item = this.nav_list[index];
      if (!item.edit_value) {
        this.$message.warning('请输入组合名称');
        return;
      }
      if (this.lock_edit) return;
      this.lock_edit = true;
      const { data } = await this.$https.get(
        `/api/v2/update_user_reit_group?group_id=${item.id}&name=${item.edit_value}`
      );
      this.$root.$emit('reloadCodeName2');
      if (data.code !== 200) {
        this.$message.error(data.msg);
        await sleep(200);
        this.lock_edit = false;
        return;
      }
      this.$emit('loadGroups', index);
      await sleep(200);
      this.lock_edit = false;
    },
    closeEdit(index) {
      const item = this.nav_list[index];
      if (!item.id) {
        this.nav_list.splice(index, 1);
        // this.$emit('update:nav_list', this.nav_list);
      } else {
        const item = this.nav_list[index];
        this.nav_list.splice(index, 1, {
          ...item,
          del_visible: false,
          edit: false,
          edit_value: item.name,
        });
        // this.$emit('update:nav_list', this.nav_list);
      }
    },
    async delItem(index) {
      const item = this.nav_list[index];
      if (this.lock_del) return;
      this.lock_del = true;
      const { data } = await this.$https.get(`/api/v2/delete_user_reit_group?group_id=${item.id}`);
      this.$root.$emit('reloadCodeName2');
      if (data.code !== 200) {
        this.$message.error(data.msg);
        await sleep(200);
        this.lock_del = false;
        return;
      }
      this.$emit('loadGroups');
      await sleep(200);
      this.lock_del = false;
    },
  },
};
</script>

<style scoped lang="less">
/deep/.cursor-pointer {
  cursor: pointer;
}
.flex {
  display: flex;
}
.items-center {
  align-items: center;
}

.page {
  color: var(--chart_title);
}

/deep/.el-popover.el-popper {
  color: red !important;
  background-color: #262629;
}

/deep/.el-table__fixed::before {
  background-color: transparent;
}

.title {
  font-size: calc(var(--ROOTFONTFIZE) * (16 / 144));
  color: var(--el-header-text-color);
}
.line {
  width: 100%;
  margin-top: 16px;
  border-bottom: 1px dashed var(--el-header-text-color);
  opacity: 0.2;
}

.btn-set {
  cursor: pointer;
  display: inline-block;
  padding: 2px 5px;
  margin-top: 10px;
  font-size: calc(var(--ROOTFONTFIZE) * (12 / 144));
  color: var(--primary-color);
  border: 1px solid var(--primary-color);
}

.title-slot {
  display: flex;
  justify-content: space-between;
  width: 45%;
  color: var(--chart_title);
}
.dialog-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .dialog-left {
    width: 47%;
    height: 480px;
    border: 1px solid #616161;
    box-sizing: border-box;
    padding: 20px;
    border-radius: 4px;
    /deep/.el-input {
      margin-left: 0;
      input {
        color: var(--table_color);
        border: none;
        background-color: var(--Btn-bgc);
      }
    }
  }
  .dialog-right {
    width: 47%;
    height: 480px;
    border: 1px solid #616161;
    box-sizing: border-box;
    padding: 20px;
    border-radius: 4px;
    .list {
      height: 440px;
      overflow: auto;
      &::-webkit-scrollbar {
        width: 10px;
        height: 10px;
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: var(--scrollbar-thumb);
      }
      .item {
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        padding: 12px;
        border-radius: 4px;
        background-color: var(--el-header-SsearchStyle-bgc);
        /deep/.el-checkbox {
          margin-left: 0;
        }
        .name {
          flex: 1;
          display: flex;
          cursor: pointer;
          margin-left: 10px;
          margin-right: 6px;
          color: var(--chart_title);
          line-height: 30px;
          .icon-wrap {
            margin-left: 4px;
            flex: none;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 20px;
            height: 20px;
            font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
            border-radius: 100%;
            background-color: #999;
          }
          /deep/.el-input {
            margin-left: 0;
            input {
              border: none;
              outline: none;
              color: var(--chart_title);
              // background-color: rgb(183, 183, 184);
              background-color: transparent;
              height: 30px;
            }
          }
        }
        .del {
          visibility: hidden;
          cursor: pointer;
          margin-right: 0;
          margin-left: auto;
          color: var(--primary-color);
          &.add {
            visibility: visible;
          }
        }
        &:hover {
          filter: brightness(0.8);
          .del {
            visibility: visible;
          }
        }
        &.add-item {
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 0;
          color: var(--primary-color);
          background-color: transparent;
          border: 1px dashed var(--primary-color);
          &.gray {
            cursor: default;
            filter: grayscale(1);
          }
        }
        &.checked {
          .name {
            color: var(--primary-color);
          }
          .el-icon-edit {
            color: var(--chart_title);
          }
        }
        &.edit {
          filter: brightness(0.8);
        }
      }
    }
  }
  .el-icon-d-arrow-right {
    // cursor: default;
    font-size: 32px;
    color: var(--primary-color);
  }
  .btn-add {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 36px;
    border-radius: 4px;
    color: var(--Btn-bgc2);
    background-color: var(--primary-color);
  }
}
.btn-confirm {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: 0;
  margin-top: 20px;
  width: 80px;
  height: 36px;
  border-radius: 4px;
  color: var(--Btn-bgc2);
  background-color: var(--primary-color);
}
/deep/.cust-dialog .el-dialog__body {
  border-top: none;
}

.tableContextmenu {
  position: fixed;
  z-index: 99;
  /deep/.el-cascader-panel {
    // height: 115px;
    height: auto;
  }
  /deep/.el-scrollbar.el-cascader-menu {
    padding-bottom: 0;
  }
  /deep/.el-cascader-menu .is-active {
    font-weight: unset;
    .el-icon-check {
      display: none;
    }
  }
}

//fix 滚动条重叠部分背景颜色
/deep/.el-table__body-wrapper::-webkit-scrollbar-corner {
  background-color: transparent;
}
/deep/.items-center {
  align-items: center;
}
/deep/.relative {
  position: relative;
}
/deep/.flex {
  display: flex;
}

/* el-table start */

::v-deep .table1 table {
  border: none;
}

::v-deep .el-table__body .el-table__row .el-table__cell {
  background-color: var(--table_bgc);
  color: var(--table_color);
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  height: calc(var(--ROOTFONTFIZE) * (60 / 144));
  border-bottom: calc(var(--ROOTFONTFIZE) * (1 / 144)) solid var(--table_brc);
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background-color: var(--table_bgc_hover);
  /* background-color: var(--table_color_hover); */
  color: var(--table_color_hover);
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell:hover {
  cursor: pointer;
}

::v-deep .el-table::before {
  background-color: var(--table_bgc);
}

::v-deep .el-table {
  border-bottom: none !important;
  background-color: var(--table_bgc);
}

/* el-table end */
</style>
